export default __webpack_public_path__ + "static/media/gable.7a8605c3.png";